import React, { memo, useMemo } from 'react';
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import {
  sharedStyles,
  sharedBoxShadow,
  sharedFontStyle,
} from '../sharedStyles';

interface DivCssProps {
  sharedStyles: SerializedStyles;
  sharedBoxShadow: SerializedStyles;
  gradientStart: string;
  gradientEnd: string;
}

interface SpanCssProps {
  spanColor: string;
  sharedFontStyle: SerializedStyles;
}

interface PrimaryButtonProps {
  gradientStart: string;
  gradientEnd: string;
  spanColor: string;
}

const Div = styled.div`
  ${({
    sharedStyles,
    sharedBoxShadow,
    gradientStart,
    gradientEnd,
  }: DivCssProps) => css`
    ${sharedStyles};
    ${sharedBoxShadow};
    grid-column-start: 1;
    grid-column-end: 3;
    width: 243px;
    background-image: linear-gradient(260deg, ${gradientStart}, ${gradientEnd});
  `}
`;
const Span = styled.span`
  ${({ spanColor, sharedFontStyle }: SpanCssProps) => css`
    color: ${spanColor};
    ${sharedFontStyle}
  `}
`;

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  gradientStart,
  gradientEnd,
  spanColor,
}) => {
  const divCssProps = useMemo(
    () => ({
      sharedStyles,
      sharedBoxShadow,
      gradientStart,
      gradientEnd,
    }),
    [gradientStart, gradientEnd]
  );
  const spanCssProps = useMemo(
    () => ({ spanColor, sharedFontStyle }),
    [spanColor]
  );
  return (
    <Div {...divCssProps}>
      <Span {...spanCssProps}>行動支付</Span>
    </Div>
  );
};

export default memo(PrimaryButton);
